export default __webpack_public_path__ + "static/media/closeChat.bffb84ce.svg";